/**
 * Pure rules for the orders recycle bin (migration 20270357).
 *
 * Kept free of any Supabase import so the countdown is testable on its own:
 * the page module constructs a client at import time, which is exactly the
 * kind of coupling that makes a two-line arithmetic function untestable.
 */

/** The window the bin advertises. Arithmetic only: nothing is scheduled to
 *  act on it, and nothing is destroyed when it reaches zero. */
export const RETENTION_DAYS = 60;

/**
 * Whole days left of the window.
 *
 * Never negative. An order past its 60 days simply reads 0 and STAYS in the
 * bin, because no automatic purge is scheduled and the flag that would let
 * one run ships false. Reaching zero is a prompt to a human, not an event.
 */
export function daysRemaining(deletedAt: string | null, now: Date = new Date()): number {
  if (!deletedAt) return RETENTION_DAYS;
  const elapsedMs = now.getTime() - new Date(deletedAt).getTime();
  const elapsedDays = Math.floor(elapsedMs / 86_400_000);
  return Math.max(0, RETENTION_DAYS - elapsedDays);
}
